import { graphql } from "gatsby"
import { compose } from "recompose"
import Page from "@views/Page"
import withTransformMenuData from "@utils/withTransformMenuData"

export const query: any = graphql`
  query Page($pageSlug: String) {
    contentfulGlobalSettings(internalTitle: { eq: "uag global settings" }) {
      countryProhibitedProducts {
        countries
        products {
          slug
        }
        message
      }
    }
    contentfulPage(slug: { eq: $pageSlug }) {
      ...PageDataFields
    }
  }
`

export default compose(withTransformMenuData)(Page)
